<template>
  <div>
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="部门管理" name="depManage">
        <DepManage></DepManage>
      </el-tab-pane>
      <el-tab-pane label="职位管理" name="posManage">
        <PositionManage></PositionManage>
      </el-tab-pane>
      <el-tab-pane label="职称管理" name="jobLevelManage">
        <JobLevelManage></JobLevelManage>
      </el-tab-pane>
      <el-tab-pane label="奖惩规则" name="ecManage">
        <EcManage></EcManage>
      </el-tab-pane>
      <el-tab-pane label="权限组" name="permissManage">
        <PermissManage></PermissManage>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import DepManage from '@/components/sysBasic/DepManage.vue'
import PositionManage from '@/components/sysBasic/PositionManage'
import JobLevelManage from '@/components/sysBasic/JobLevelManage'
import EcManage from '@/components/sysBasic/EcManage'
import PermissManage from '@/components/sysBasic/PermissManage'

export default {
  name: "SysBasic",
  data() {
    return {
      activeName: 'depManage'
    }
  },
  components: {
    DepManage,
    PositionManage,
    JobLevelManage,
    EcManage,
    PermissManage
  }
}
</script>

<style scoped>

</style>